import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { OnboardingShell } from "@/components/onboarding/OnboardingShell";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export default function WelcomeSuccess() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [firstName, setFirstName] = useState("");
  const [memberRecordId, setMemberRecordId] = useState<string | null>(null);
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    let active = true;
    (async () => {
      const { data } = await (supabase as any)
        .from("member_records")
        .select("id, first_name")
        .eq("user_id", user.id)
        .maybeSingle();
      if (!active || !data) return;
      if (data.first_name) setFirstName(String(data.first_name).trim());
      if (data.id) setMemberRecordId(String(data.id));
    })();
    return () => {
      active = false;
    };
  }, [user?.id]);

  const begin = async () => {
    setStarting(true);
    if (memberRecordId) {
      await (supabase as any).from("onboarding_state").upsert(
        {
          member_record_id: memberRecordId,
          intro_acknowledged_at: new Date().toISOString(),
        },
        { onConflict: "member_record_id" },
      );
    }
    navigate("/onboarding");
  };

  return (
    <OnboardingShell currentPhase={1}>
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">
            {firstName
              ? `Your account is ready for you, ${firstName}.`
              : "Your account is ready for you."}
          </CardTitle>
          <CardDescription>Here's what's coming next.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm leading-relaxed">
            Take 10 minutes to move through the onboarding steps.
          </p>
          <p className="text-sm leading-relaxed">
            We will take you through a quick process that will ask a few questions that we need to
            know to make the Association. Then we'll request your permission with a signature so
            that we can get to work for you.
          </p>
          <p className="text-sm leading-relaxed">
            All of this happens right here in the portal. If you ever need to step away and come
            back, we will save your spot and all the info you have submitted.
          </p>
          <p className="text-sm leading-relaxed">
            If you get stuck, just use the Feedback button to let us know what's going on.
          </p>

          <Button className="w-full min-h-[48px]" size="lg" onClick={begin} disabled={starting}>
            Begin
          </Button>
        </CardContent>
      </Card>
    </OnboardingShell>
  );
}
